import { Component } from 'react';
import { inject, observer } from 'mobx-react';
import propTypes from 'prop-types';

import * as constants from '../../../../constants/constants';
import { PesIcon } from '@pes-ui/components-react';
import { pesIconSizes,  pesIconMirrorDirection } from '@pes-ui/components/dist/collection/components/UI/pes-icon/constants';

class _ExpandToggle extends Component {
  render() {
    const { labelsStore, item } = this.props;
    const groupLabel = item.isShown
      ? labelsStore.hideProducts
      : labelsStore.viewProducts.replace(constants.REPLACE_QTY, item.products.length);

    return (
      <div
        className="cart-table__row cart-group__footer"
        onClick={item.toggleGroup}
      >
        <span>{groupLabel}</span>
        <PesIcon class="cart-group__arrow-icon" 
          size={pesIconSizes.NANO}
          mirror={!item.isShown ? pesIconMirrorDirection.VERTICAL : undefined}  
        >
          arrow2_up
        </PesIcon>
      </div>

    );
  }
}

_ExpandToggle.propTypes = {
  item: propTypes.shape({
    products: propTypes.object,
    isShown: propTypes.bool,
    toggleGroup: propTypes.func
  }).isRequired,

  labelsStore: propTypes.shape({
    viewProducts: propTypes.string,
    hideProducts: propTypes.string
  }).isRequired

};

export const ExpandToggle = inject('labelsStore')(observer(_ExpandToggle));
